import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { projectsStagingManageStart } from "Store/Actions";
import { selectSelectedOrActiveProjectIds } from "Store/Selectors/Projects";
import { hasElements } from "Utils/Array";
import { IAction } from "./IAction";

export function useManageIgnoredSourceData(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();
  const selectedProjectIds = useSelector(selectSelectedOrActiveProjectIds);
  const allowManageIgnoredSourceData = hasElements(selectedProjectIds) && selectedProjectIds.length === 1;

  const onManageIgnoredSourceData = useCallback(async () => {
    if (!allowManageIgnoredSourceData) {
      return;
    }

    await preflightAuthentication();
    dispatch(projectsStagingManageStart());
  }, [allowManageIgnoredSourceData, dispatch, preflightAuthentication]);

  return [allowManageIgnoredSourceData, onManageIgnoredSourceData];
}
